import { tns } from "tiny-slider/src/tiny-slider";
import LazyLoad from "vanilla-lazyload";
import init from "./common";

init();
// Init Lazy load instance
var lazyLoad = new LazyLoad();
function sliderLazy() {
  lazyLoad.update();
}

// Init slider pour .slider-publications
var sliderActualites = tns({
  container: ".slider-actualites",
  items: 1,
  slideBy: "page",
  autoplay: false,
  nav: false,
  controls: true,

  controlsContainer: ".controls-slider-actualites",
  responsive: {
    0: {
      items: 1,
      gutter: 0,
    },
    900: {
      items: 2,
      gutter: 40,
    },
    1280: {
      items: 3,
      gutter: 60,
    },
  },
});
sliderActualites.events.on("indexChanged", sliderLazy);
var agenda = jQuery("#agenda-home");
if (agenda.length > 0) {
  var sliderAgenda = tns({
    container: ".slider-agenda",
    slideBy: "page",
    autoplay: false,
    nav: false,
    controls: true,
    controlsContainer: ".controls-slider-agenda",
    responsive: {
      0: {
        items: 1,
        gutter: 0,
      },
      900: {
        items: 2,
        gutter: 80,
      },
      1280: {
        gutter: 40,
      },
      1440: {
        gutter: 60,
      },
    },
  });
  sliderAgenda.events.on("indexChanged", sliderLazy);
}
var sliderChiffres = tns({
  container: ".slider-chiffres",

  loop: true,
  autoplay: false,
  nav: false,
  controls: true,
  controlsContainer: ".controls-slider-chiffres",
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    1024: {
      items: 3,
    },
    1200: {
      items: 4,
    },
    1400: {
      items: 5,
    },
  },
});
sliderChiffres.events.on("indexChanged", sliderLazy);

jQuery("#carte-home path").on("mouseenter", function () {
  const pathId = jQuery(this).data("id");
  const nomId = jQuery(".commune-" + pathId);
  //get html content
  const nom = nomId.html();
  jQuery(".commune").removeClass("active");
  nomId.addClass("active");
  jQuery("#info-box").css("display", "flex");
  jQuery("#info-box").html(nom);
});
jQuery("#carte-home path").on("mouseleave", function () {
  jQuery(".commune").removeClass("active");
  jQuery("#info-box").css("display", "none");
});

jQuery(document)
  .on("mousemove", function (e) {
    jQuery("#info-box").css("top", e.pageY - 90);
    jQuery("#info-box").css("left", e.pageX - 30);
  })
  .mouseover();

jQuery("#carte-home path").on("click", function () {
  const pathId = jQuery(this).data("id");
  const nomId = jQuery(".commune-" + pathId);
  window.location.href = nomId.data("url");
});

jQuery(".commune").on("mouseenter", function () {
  jQuery("#carte-home path").css("fill", "#fff");
  const pathId = jQuery(this).data("id");
  const path = jQuery("#carte-home path[data-id=" + pathId + "]");
  path.css("fill", "#d1c84c");
});

// add negative top to .separator-svg  equals to .separator-svg height
jQuery(".separator-svg").css("top", -jQuery(".separator-svg").height() + 1);
jQuery(".separator-content").css(
  "top",
  -jQuery(".separator-svg").height() / 2.5
);
// also when resize
jQuery(window).resize(function () {
  jQuery(".separator-svg").css("top", -jQuery(".separator-svg").height());
  jQuery(".separator-content").css(
    "top",
    -jQuery(".separator-svg").height() / 2.5
  );
});
